var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-4b60362c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex justify-center items-center" };
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = {
    key: 1,
    class: "opacity-50 text-xs xs:text-sm"
};
import { computed, ref, toRefs } from 'vue';
import EButton from '@common/ui/EButton.vue';
import EIcon from '@common/ui/EIcon.vue';
import ECircleMark from '@common/ui/ECircleMark/ECircleMark.vue';
import { UpdateNotificationViewedStatusFragmentDoc, useSetNotificationReadedMutation, useSetNotificationUnreadedMutation, } from '@common/graphql/operations';
import EAvatar from '@common/ui/EAvatar/EAvatar.vue';
import { useSchoolNotificationRedirect, } from '@common/components/Notifications/hooks/useSchoolNotificationRedirect';
import { useStudentNotificationRedirect } from '@common/components/Notifications/hooks/useStudentNotificationRedirect';
import Auth from '@common/modules/auth';
import { formatDateToDays } from '@common/components/Notifications/helpers/formatDateToDays';
import { useGetNotificationAvatar } from '@common/components/Notifications/hooks/useGetNotificationAvatar';
import { useGetNotificationIcon } from '@common/components/Notifications/hooks/useGetNotificationIcon';
import ETooltip from '@common/ui/ETooltip.vue';
import apolloClient from '../../../../../apolloClient';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationItem',
    props: {
        notification: {},
        variant: { default: 'detailed' }
    },
    emits: ["close"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var notification = toRefs(props).notification;
        var isNotificationHovering = ref(false);
        var schoolRedirect = useSchoolNotificationRedirect(notification.value.action, notification.value.meta).goToRoute;
        var studentRedirect = useStudentNotificationRedirect(notification.value.action, notification.value.meta).goToRoute;
        var _b = useGetNotificationAvatar(notification.value.action, notification.value.meta), name = _b.name, avatarSrc = _b.avatarSrc, avatarIcon = _b.avatarIcon, colorId = _b.colorId, avatarClass = _b.avatarClass;
        var _c = useGetNotificationIcon(notification.value.action), statusIcon = _c.statusIcon, statusIconClass = _c.statusIconClass;
        var variantClass = computed(function () {
            return {
                detailed: 'notification-item--detailed',
                simplified: 'notification-item--simplified'
            }[props.variant];
        });
        var isStudent = computed(function () { return Auth.isStudentUser(); });
        var _d = useSetNotificationReadedMutation(function () { return ({
            variables: {
                id: notification.value.id
            }
        }); }), read = _d.mutate, onDoneRead = _d.onDone;
        onDoneRead(function () {
            apolloClient.cache.modify({
                id: apolloClient.cache.identify({ __typename: 'Query', id: 'ROOT_QUERY' }),
                fields: {
                    notificationsCount: function (existingNotificationsCount) {
                        if (existingNotificationsCount === void 0) { existingNotificationsCount = []; }
                        return existingNotificationsCount.map(function (item) {
                            return item.group === notification.value.group
                                ? __assign(__assign({}, item), { countUnread: item.countUnread - 1 }) : item;
                        });
                    },
                },
            });
            apolloClient.cache.writeFragment({
                id: apolloClient.cache.identify({ __typename: 'UserNotificationOutput', id: notification.value.id }),
                fragment: UpdateNotificationViewedStatusFragmentDoc,
                data: {
                    viewed: true,
                },
            });
        });
        var _e = useSetNotificationUnreadedMutation(function () { return ({
            variables: {
                id: notification.value.id
            }
        }); }), markUnread = _e.mutate, onDoneUnreaded = _e.onDone;
        onDoneUnreaded(function () {
            apolloClient.cache.modify({
                id: apolloClient.cache.identify({ __typename: 'Query', id: 'ROOT_QUERY' }),
                fields: {
                    notificationsCount: function (existingNotificationsCount) {
                        if (existingNotificationsCount === void 0) { existingNotificationsCount = []; }
                        return existingNotificationsCount.map(function (item) {
                            return item.group === notification.value.group
                                ? __assign(__assign({}, item), { countUnread: item.countUnread + 1 }) : item;
                        });
                    }
                },
            });
            apolloClient.cache.writeFragment({
                id: apolloClient.cache.identify({ __typename: 'UserNotificationOutput', id: notification.value.id }),
                fragment: UpdateNotificationViewedStatusFragmentDoc,
                data: {
                    viewed: false, // Обновляем статус прочтения
                },
            });
        });
        var foramtedDate = computed(function () { return formatDateToDays(new Date(notification.value.createdAt)); });
        var handleNotificationRedirect = function () {
            if (isStudent.value) {
                studentRedirect();
            }
            else {
                schoolRedirect();
            }
        };
        var handleReadedStatus = function () {
            if (notification.value.viewed) {
                markUnread();
            }
            else {
                read();
            }
        };
        var handleNotificationClick = function () {
            handleNotificationRedirect();
        };
        var handleClose = function () {
            emit('close', notification.value.id);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([variantClass.value, "notification-item"]),
                onClick: handleNotificationClick,
                onMouseleave: _cache[0] || (_cache[0] = function ($event) { return (isNotificationHovering.value = false); }),
                onMouseover: _cache[1] || (_cache[1] = function ($event) { return (isNotificationHovering.value = true); })
            }, [
                _createVNode(ETooltip, {
                    "tooltip-text": _unref(notification).viewed ? _unref(t)('notification.markAsUnread') : _unref(t)('notification.markAsRead'),
                    theme: "dark",
                    trigger: "hover",
                    fullwidth: "",
                    unselectablew: ""
                }, {
                    default: _withCtx(function () { return [
                        (_ctx.variant === 'detailed')
                            ? (_openBlock(), _createBlock(ECircleMark, {
                                key: 0,
                                theme: _unref(notification).viewed ? 'gray' : 'green',
                                onClick: _withModifiers(handleReadedStatus, ["stop"])
                            }, null, 8, ["theme"]))
                            : _createCommentVNode("", true)
                    ]; }),
                    _: 1
                }, 8, ["tooltip-text"]),
                _createElementVNode("div", {
                    class: _normalizeClass([[_unref(avatarIcon) && _unref(avatarClass)], "ml-2 w-9 h-9 rounded-full shrink-0 relative flex justify-center items-center"])
                }, [
                    (_unref(avatarSrc) || _unref(colorId) || _unref(name))
                        ? (_openBlock(), _createBlock(EAvatar, {
                            key: 0,
                            "color-id": _unref(colorId),
                            icon: _unref(avatarIcon),
                            name: _unref(name),
                            src: _unref(avatarSrc)
                        }, null, 8, ["color-id", "icon", "name", "src"]))
                        : (_openBlock(), _createBlock(EIcon, {
                            key: 1,
                            icon: _unref(avatarIcon)
                        }, null, 8, ["icon"])),
                    _createElementVNode("div", _hoisted_1, [
                        (_unref(statusIcon))
                            ? (_openBlock(), _createBlock(EIcon, {
                                key: 0,
                                class: _normalizeClass([_unref(statusIconClass), "absolute -right-1 -bottom-1 z-10 w-3.5 h-3.5"]),
                                icon: _unref(statusIcon)
                            }, null, 8, ["class", "icon"]))
                            : _createCommentVNode("", true)
                    ])
                ], 2),
                _createElementVNode("div", {
                    class: "max-w-64 ml-4 mr-2 text-sm xs:text-base",
                    innerHTML: _unref(notification).text
                }, null, 8, _hoisted_2),
                (_ctx.variant === 'detailed')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([[!isNotificationHovering.value && 'self-end'], "ml-auto w-auto xs:w-24 flex shrink-0"])
                    }, [
                        (isNotificationHovering.value)
                            ? (_openBlock(), _createBlock(EButton, {
                                key: 0,
                                class: "ml-auto shrink-0",
                                type: "secondary",
                                onClick: handleNotificationRedirect
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(EIcon, {
                                        class: "w-2.5 h-2.5",
                                        icon: "notifications/notification-redirect"
                                    })
                                ]; }),
                                _: 1
                            }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(foramtedDate.value), 1))
                    ], 2))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "ml-auto w-7 h-7 flex justify-center items-center rounded-md hover:bg-gray/[0.05]",
                        onClick: _withModifiers(handleClose, ["stop"])
                    }, [
                        _createVNode(EIcon, {
                            class: "w-2.5 h-2.5 text-gray/40",
                            icon: "close"
                        })
                    ]))
            ], 34));
        };
    }
});
